import React from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Input, Button, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const NewDiscountCodeModal = ({ isOpen, toggle, onSave, discountCode, onInputChange }) => {
    let parsedDate = null;
    if (discountCode.expires_at && moment(discountCode.expires_at, "MM/DD/YYYY [at] hh:mm A").isValid()) {
       parsedDate = moment(discountCode.expires_at, "MM/DD/YYYY [at] hh:mm A"); 
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} autoFocus={false}>
            <ModalHeader toggle={toggle}>New Discount Code</ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); onSave(discountCode); }}>
                    <FormGroup>
                        <Label for="code">Code</Label>
                        <Input
                            type="text"
                            name="code"
                            id="code"
                            value={discountCode.code}
                            onChange={(e) => onInputChange('code', e.target.value)}
                            placeholder="Discount code"
                            required
                            autoFocus={true}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="discountAmount">Discount Amount</Label>
                        <Input
                            type="text"
                            placeholder="Enter dollar amount"
                            name="discountAmount"
                            id="discountAmount"
                            value={discountCode.discount_amount}
                            onChange={(e) => onInputChange('discount_amount', e.target.value)}
                            required
                            invalid={!/^\d*\.?\d{0,2}$/.test(discountCode.discount_amount)}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="expiresAt">Expires</Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <DatePicker 
                                id="expiresAt"
                                name="expiresAt"
                                className="form-control"
                                selected={parsedDate ? parsedDate.toDate() : ''}
                                onChange={(date) => onInputChange('expires_at', date)}
                                showTimeSelect
                                timeInterval={15}
                                dateFormat="MM/dd/yyyy h:mm aa"
                                style={{ marginLeft: '10px' }} 
                            />
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label for="description">Description</Label>
                        <Input
                            type="text"
                            name="description"
                            id="description"
                            value={discountCode.description}
                            onChange={(e) => onInputChange('description', e.target.value)}
                        />
                    </FormGroup>

                    <Button color="primary" type="submit">Save</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default NewDiscountCodeModal;
